import { Box, Container, Fade, Grow, Stack, Typography } from "@mui/material";
import parse from "html-react-parser";
import React from "react";

import Header from "../components/Header";
import Nav from "../components/navComponents/Nav";

import useContent from "../hooks/useContent";
import useInView from "../hooks/useInView";
import { theme } from "../utils/theme";

const HEADER_HEIGHT = { xs: 240, sm: 320 };

const AboutPage = () => {
  const content = useContent();
  const [setRef, visible] = useInView({
    threshold: 0.1,
  });

  return (
    <Box>
      <Nav />

      <Box
        sx={{
          alignItems: "center",
          background: `url(${content.about.image})`,
          backgroundAttachment: "fixed",
          backgroundColor: theme.palette.primary.dark,
          backgroundPosition: "bottom center !important",
          backgroundRepeat: "no-repeat !important",
          backgroundSize: "cover !important",
          display: "flex",
          height: HEADER_HEIGHT,
          justifyContent: "center",
          left: { xs: 0, sm: 0 },
          top: 0,
          width: "100%",
          zIndex: 1,
        }}
      >
        <Container maxWidth="lg">
          <Fade in={visible} timeout={500}>
            <Stack spacing={4}>
              <Header
                center={true}
                data={content.about}
                headerRef={setRef}
                style={{ color: theme.palette.grays.white }}
              />
            </Stack>
          </Fade>
        </Container>
      </Box>

      <Container maxWidth="md" sx={{ pb: 24, pt: { xs: 8, md: 20 } }}>
        <Stack spacing={8}>
          <Grow in={visible} timeout={800}>
            <Typography
              sx={{
                color: theme.palette.grays[900],
                fontSize: {
                  xs: theme.typography.body2,
                  md: theme.typography.h5,
                },
                fontWeight: 300,
                mb: { xs: 4, md: 0 },
                mt: { xs: 0, md: 6 },
                textAlign: { xs: "start", md: "start" },
                textTransform: "none",
              }}
            >
              {parse(content.about.content)}
            </Typography>
          </Grow>
        </Stack>
      </Container>

      {/* <Team /> */}
    </Box>
  );
};

export default AboutPage;
